// @LTG-ID: F-011
// @STATUS: BUILT
// @HERMETIC: false  // consumes ExternalCTA, LEVERS
// @DOCS: 08_FEATURES.md#F-011, source Landing Page.html lines 2476-2518
// @CHANGED: 2026-02 session_003 (CHG-0040)
// @OWNER: web
//
// F-011 — 10-lever scorecard. Verbatim port of source lines 2476-2518.
// Single-active-card expand pattern (React state). Teal meter fill animates
// from 0 → val% on first render via CSS transition. No sector dependency.

import { useState } from "react";
import { LEVERS } from "../../data/levers";
import ExternalCTA from "../../lib/external-cta";
import "./levers.css";

export function Levers() {
    const [open, setOpen] = useState(null);

    return (
        <section
            className="ltg-levers-section"
            id="levers"
            data-testid="levers-section"
        >
            <div className="ltg-container">
                <div className="ltg-block-head">
                    <span
                        className="ltg-eyebrow"
                        data-testid="levers-eyebrow"
                    >
                        The model
                    </span>
                    <h2 data-testid="levers-h2">
                        Ten levers move <em>every</em> business value. Tap one.
                    </h2>
                </div>

                <div
                    className="ltg-levers-grid"
                    role="list"
                    data-testid="levers-grid"
                >
                    {LEVERS.map((l, i) => {
                        const isOpen = open === i;
                        return (
                            <button
                                type="button"
                                role="listitem"
                                key={l.title}
                                className={
                                    "ltg-lever" + (isOpen ? " ltg-lever--open" : "")
                                }
                                aria-expanded={isOpen}
                                aria-controls={`lever-detail-${i}`}
                                onClick={() =>
                                    setOpen(isOpen ? null : i)
                                }
                                data-testid={`lever-card-${i}`}
                            >
                                <span className="ltg-lever__num">
                                    L/{String(i + 1).padStart(2, "0")}
                                </span>
                                <h4 className="ltg-lever__title">{l.title}</h4>
                                {isOpen && (
                                    <div
                                        id={`lever-detail-${i}`}
                                        className="ltg-lever__detail"
                                        data-testid={`lever-detail-${i}`}
                                    >
                                        {l.desc}
                                    </div>
                                )}
                                <div className="ltg-lever__meter">
                                    <div
                                        className="ltg-lever__meter-fill"
                                        style={{ width: `${l.val}%` }}
                                    />
                                </div>
                                <div className="ltg-lever__meter-label">
                                    <span>Industry median</span>
                                    <span>{l.val}/100</span>
                                </div>
                            </button>
                        );
                    })}
                </div>

                <p className="ltg-levers__caption">
                    Score range is illustrative · the full assessment scores
                    your business against ~3,400 owner-operated peers
                </p>

                <div className="ltg-levers__cta">
                    <span className="ltg-levers__cta-line">
                        Every lever above scored against your specific business,
                        in your Snapshot.
                    </span>
                    <ExternalCTA
                        ctaId="levers-order"
                        className="ltg-btn ltg-btn-primary"
                        data-testid="levers-order-cta"
                    >
                        Get Your Valuation{" "}
                        <span className="ltg-arrow" aria-hidden="true">
                            →
                        </span>
                    </ExternalCTA>
                </div>
                <p className="ltg-levers__disclaimer">
                    Indicative valuation. Not a formal appraisal under SSVS
                    No. 1.
                </p>
            </div>
        </section>
    );
}

export default Levers;
